import {RootStore} from '../index';
import {action, makeAutoObservable} from "mobx"

import ElementModel from "../../model/ElementModel";
import BlockPropertyModel from "../../model/BlockPropertyModel";


export class PageBrandsStore {
    private rootStore: RootStore | undefined;


    arBrand = [];
    arBrand2 = [];
    filter = {};

    clientId: number | undefined = 0

    public error: string = '';

    pagination = {
        countPage: 1,
        countRow: 1,
        currentPage: 1
    }

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init(page: any) {

        if (page > 0){
            this.pagination.currentPage = page
        }
        this.arBrand = [];
        this.clientId = this.rootStore?.mainStore.getClientId()
        if (this.clientId) {
            ElementModel.getBrands({
                json: { 
                    clientId: this.clientId,
                    filter: this.filter,
                    limit: 500,
                    sort:{
                        orderField: 'name',
                        orderBy: 'ASC',
                      }
                },
                page: this.pagination.currentPage
            }, this.setBrands, this.setError);


        }
        this.rootStore?.basePageStore.setBreadCrumbs([], "brands")
    }


    onCurrentPage = (page: number) => {

        let url = "brands/" + page
        window.location.pathname = url
        this.pagination.currentPage = page;
        this.init(page);
    }


    @action setBrands = (result: any) => {
        this.pagination = result.data.pagination

        this.arBrand = result.data.rows;
        if (result) {
            BlockPropertyModel.getBrand({
                json: {
                    clientId: this.clientId,
                    filter: this.filter,
                    limit: 500,
                },
                page: this.pagination.currentPage
            }, this.setBrands2, this.setError);
        }
    }
    @action setBrands2 = (result: any) => {
        if (result) {
            this.arBrand2 = result.data.enum
            this.activeInactive()
        }


    }

    activeInactive() {

        for (let i = 0; i < this.arBrand.length; i++) {

            for (let a = 0; a < this.arBrand2.length; a++) {

                // @ts-ignore
                if (this.arBrand2[a].id === this.arBrand[i].id) {

                    // @ts-ignore
                    this.arBrand[i].active = false

                }

            }
        }

    }


    @action
    setError = (error: any) => {
        console.log(error);
        // this.error = error.response.data.message;
    }


}